import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MandateCalendarUseCase extends BaseUseCase {
    constructor(mandateCalendarRep) {
        super();
        this.mandateCalendarRep = mandateCalendarRep;
    }
    async fetchResult(req) {
        return await this.mandateCalendarRep.mandateCalendarData(req);
    }
}
export default MandateCalendarUseCase;
